// extracted by mini-css-extract-plugin
module.exports = {"webViewerContainer":"PDFDocument_webViewerContainer__3O50D","webViewer":"PDFDocument_webViewer__Ids7p"};